import { Component, Input, OnInit } from '@angular/core';
import { LayoutService } from '../../layout.service';
import * as Handlebars from 'handlebars';

@Component({
  selector: 'app-timeline-section',
  templateUrl: './timeline-section.component.html',
  styleUrls: ['./timeline-section.component.less'],
})
export class TimelineSectionComponent implements OnInit {
  @Input() queryId = 0;
  @Input() parameters: { [key: string]: any };
  @Input() selectedId: number | string;
  @Input() actionType = '';

  timeLineNodes = [];

  constructor(private layoutService: LayoutService) {}

  ngOnInit(): void {
    this.layoutService
      .executeQuery(this.queryId, this.parameters)
      .subscribe((d: any[]) => {
        for (const row of d) {
          row.Text = this.getRecordHtml(row.Text, row);
        }

        this.timeLineNodes = d;
      });
  }

  getRecordHtml(text, record) {
    const template = Handlebars.compile(text);
    const html = template(record);
    return html;
  }
}
